var VideoPlayer = {

    me: this,
    _videoPlayer: null,
    _heroVideoPlayer: null,


    InitVideoPlayer: function (_videoId) {
        this._videoPlayer = document.querySelector('#'+_videoId).querySelector('.video-container');

        this._videoPlayer.addEventListener('click', function (event) {
            event.preventDefault();
            // Hide the thumb
            if(this._videoPlayer.querySelector("picture") !== null) {
                this._videoPlayer.querySelector("picture").classList.add('hidden');
            }
            this._videoPlayer.querySelector(".video-panel__holder").classList.remove('hidden')
            this._videoPlayer.classList.add('video-container--active');

            // Vimeo api
            var iframe = this._videoPlayer.querySelector('iframe');
            var player = new Vimeo.Player(iframe);
            
            player.play();

            
        }.bind(this), false);
    },


    InitHeroPlayer: function () {
        this._heroVideoPlayer = document.querySelector('#heroVideo');

        this._heroVideoPlayer.querySelector('.hero__button').addEventListener('click', function (event) {
            event.preventDefault();

            // console.log('here');

            // Hide the thumb
            if(this._heroVideoPlayer.querySelector("picture") !== null) {
                this._heroVideoPlayer.querySelector("picture").classList.add('hidden');
            }
            this._heroVideoPlayer.querySelector(".video-panel__holder").classList.remove('hidden')
            this._heroVideoPlayer.classList.add('video-container--active');

            // Vimeo api
            var iframe = this._heroVideoPlayer.querySelector('iframe');
            var player = new Vimeo.Player(iframe);
            player.play();

        }.bind(this), false);
    }
}